import React, { Component } from 'react'
import { Icon } from 'loyal-react'
// import PropTypes from 'prop-types'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'

import '@loyal_molecules/accordion.css'
import 'react-accessible-accordion/dist/fancy-example.css'

class FaqTwoStep extends Component {
  render () {
    return (
      <div className='container mt-5 mt-md-0 px-0 px-md-1 pt-1 pt-md-0 py-md-4'>
        <div className='row mx-0 ${this.state.sendDocuments'>
          <div className='col-12 border-color-ui-3 bg-white border radius'>
            <div className='row px-1 py-2 border-bottom border-color-ui-3'>
              <div className='col mr-auto'>
                <h3 className='txt-title txt-circular-book txt-initial color-ui-black mr-auto'>
                  Dúvidas frequentes
                </h3>
              </div>
            </div>
            <div className='row px-2 py-2 border-bottom border-color-ui-3'>
              <Accordion
                className='row col-12 mx-0 px-0 mx-md radius-0 radius-md bg-white border-left border-top border-right border-color-ui-3'
                accordion
              >
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Por qual motivo devo cadastrar meu celular?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          Para que seus resgates no Catálogo de Prêmios ocorram de forma segura. Assim saberemos que apenas você estará utilizando seus pontos e não um possível fraudador.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Como funcionam os resgates após o cadastro do meu celular?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          Sempre que você efetuar resgate em uma das lojas parceiras constantes no Catálogo de Prêmios será enviado o token para o seu celular, que deverá ser informado para que haja a conclusão do seu resgate.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          O que é token?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          Token é um dispositivo eletrônico que gera senhas numéricas aleatórias. Foi criado para proporcionar ainda mais segurança aos usuários da internet em transações virtuais (compras, acesso a contas bancárias, atualização de dados cadastrais, etc.) e assim dificultar a ação de hackers e fraudadores.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Qual a necessidade de enviar meus documentos para validar meu celular?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          O envio de documentos é apenas um método alternativo para validar seu celular. Ele será solicitado somente se você não receber o e-mail para ativação do dispositivo, que será utilizado para confirmar os resgates no Catálogo de Prêmios.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Quais são os documentos necessários para a validação do meu celular?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          RG e CPF ou CNH. Os documentos devem ser digitalizados totalmente abertos, sem cortes ou efeitos que impossibilite a leitura de todos os dados.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Qual o prazo para validação do meu celular após o envio de documentos?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          Após o envio dos documentos sua solicitação de validação do celular entrará em análise e em até 72 horas você será notificado por e-mail sobre o resultado.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Enviei os documentos e não tive o celular validado. O que devo fazer?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          Entre em contato com a Central de Atendimento da sua Campanha de Premiação para verificar o que pode ter ocorrido.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
                <AccordionItem
                  className='filter-accordion filtered-accordion border-color-ui-3 col-12 px-0'
                  expanded={false}
                >
                  <AccordionItemTitle className='filter-accordion cursor border-bottom border-color-ui-3 col-12 px-0'>
                    <div className='row mx-0 align-items-center h-100 px-1 py-2'>
                      <div className='col'>
                        <p className='txt-title-3 txt-font-body color-ui-1'>
                          Se eu tiver mais dúvidas sobre a validação do celular, o que devo fazer?
                        </p>
                      </div>
                      <div className='col-auto'>
                        <Icon className='icon icon_down icon-sm' />
                      </div>
                    </div>
                  </AccordionItemTitle>
                  <AccordionItemBody className='panel-accordion panel-faq border-bottom border-color-ui-3 bg-ui-5 px-2 py-2 bg-0'>
                    <div className='row'>
                      <div className='col-12 px-1'>
                        <p className='txt-body-sm txt-font-body'>
                          Nosso time está preparado para responder as suas dúvidas e auxiliar no que for necessário. Basta entrar em contato por meio da Central de Atendimento da sua Campanha de Premiação.
                        </p>
                      </div>
                    </div>
                  </AccordionItemBody>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

// FaqTwoStep.propTypes = {
// }

export default FaqTwoStep



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/FaqTwoStep.js